var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rj-tabs',{model:{value:(_vm.tabsActive),callback:function ($$v) {_vm.tabsActive=$$v},expression:"tabsActive"}},[_c('rj-tab-pane',{attrs:{"name":"1","label":"待打印发货单唛头"}},[_c('wait-print',{ref:"waitPrintRef"})],1),_c('rj-tab-pane',{attrs:{"name":"2","label":"已打印发货单唛头"}},[_c('already-print',{ref:"alreadyPrintRef"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }